'use client';
import { useMemo } from 'react';

const useCastNumbers = (data: any, mappings: any) =>
  useMemo(
    () =>
      data.map((dataPoint: any) =>
        mappings.reduce(
          (acc: any, mapping: any) =>
            Object.assign(acc, { [mapping.dataKey]: Number(dataPoint[mapping.dataKey]) || 0 }),
          { ...dataPoint },
        ),
      ),
    [data, mappings],
  );

export default useCastNumbers;
